export default __webpack_public_path__ + "0e61164434500ba53a7d5867e93a6b27.png";